/**
 * user that the id scan is for
 */

import { createSlice } from "@reduxjs/toolkit";

export const scanUserSlice = createSlice({
  name: "scanUser",
  initialState: {
    value: null,
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { update } = scanUserSlice.actions;

export default scanUserSlice.reducer;
